//const token = 'EAAJHJsDGdIMBPaNmPWdQURHHwBMlnFj7ZCS0PcbZCeAveWj0ANQU5cGPPxKq5jZAWwqVlXYZA1qHI8iEiZB504wnkqqiQTvAAOYWbNdv2OBeZCcrKh6Hxz43LuJZBF29nQ8DzJmB8ZCMaTiCENzd87leEuZA6TXDLIL2G52xCxZCinvRp8CsBakS3rpXDVUgZDZDO';
//const userId = '574605529074655';
import React, { useEffect, useState } from 'react';

function Galeria() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    document.title = 'Galería';

    const fetchInstagramPosts = async () => {
      try {
        const token = 'EAAJHJsDGdIMBPW4ZCssTajk8TbCMv04d6AjNKintDSu4AYU4MuGsHgV8nG0VTuq9dZA6TMvuXlzCPPLoYS54jXrtpHeEvazDgHZA5GG8SudlmfIpc8ZBlJ2J89uxh4EQOZBfLwT8O0lNywmQPntbRoqZAzPouxFYfUMn3coGzVBGNGVWf2lACygLxytwZDZD';
        const userId = '17841400697648029';
        
        const fields = 'id,caption,media_type,media_url,permalink,thumbnail_url,timestamp,username';
        //const url = `https://graph.instagram.com/me/media?fields=${fields}&access_token=${token}`;
        const url = `https://graph.facebook.com/v21.0/${userId}/media?fields=id,caption,media_type,media_url,permalink,thumbnail_url,timestamp,username&access_token=${token}`;
        //https://graph.facebook.com/v21.0/{IG_USER_ID}/media?fields=id,caption,media_type,media_url,permalink,thumbnail_url,timestamp,username&access_token={TU_TOKEN}
        const response = await fetch(url);
        const data = await response.json();
        setPosts(data.data || []);
      } catch (error) {
        console.error('Error al obtener publicaciones de Instagram:', error);
      }
    };

    fetchInstagramPosts();
  }, []);

  useEffect(() => { document.title = 'Galería'; }, []);
  return (
    <section className="first-section-padding section-bottom-border">
      <div className="container">
        {/*<div className="row">
          {posts.map((post) => (
            <div key={post.id} className="col-lg-4 col-md-3 mb-4">
              <a href={post.permalink} target="_blank" rel="noopener noreferrer">
                {post.media_type === 'IMAGE' || post.media_type === 'CAROUSEL_ALBUM' ? (
                  <img src={post.media_url} alt={post.caption || "Imagen de Instagram"} className="img-fluid rounded" />
                ) : post.media_type === 'VIDEO' ? (
                  <video controls className="img-fluid rounded">
                    <source src={post.media_url} type="video/mp4" />
                  </video>
                ) : null}
              </a>
              
            </div>
          ))}
        </div>*/}
        <div className="row">
          {posts.filter((post) => post.media_type === "IMAGE" || post.media_type === "CAROUSEL_ALBUM")
            .map((post) => (
              <div key={post.id} className="col-lg-4 col-md-3 col-6 mb-4">
                <a href={post.permalink} target="_blank" rel="noopener noreferrer">
                  <img
                    src={post.media_url}
                    alt={post.caption || "Imagen de Instagram"}
                    className="img-fluid rounded"
                  />
                </a>
              </div>
            ))}
        </div>
        {/*<div className="row">
          <h2>Videos</h2>
          {posts.filter((post) => post.media_type === 'VIDEO')
            .map((post) => (
              <div key={post.id} className="col-lg-4 col-md-3 mb-4">
                <a href={post.permalink} target="_blank" rel="noopener noreferrer">
                  <video controls className="img-fluid rounded">
                    <source src={post.media_url} type="video/mp4" />
                  </video>
                </a>
              </div>
            ))}
        </div>*/}
      </div>
    </section>
  );
}

export default Galeria; 